import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const mdmeldConfig: TSPConfig = {
  key: 'mdmeld',
  name: 'MDMELD',
  imageName: 'mdmeld',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API key from MDMELD support, then enter it below.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default mdmeldConfig;
